<template>
  <div class="newwarp boxsizing miniwarp gray80">
    <div class="auto">
      <page-title title="详情" icon="fa-user-circle"></page-title>
    </div>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div v-loading="loading">
          <sp-user-filters :filters="filters" :noheader="true" :chooseValDemo="chooseValStr" @getValues="getValues"></sp-user-filters>
        </div>
      </el-col>
    </el-row>
    <el-row class="m-t-15">
      <el-col :span="24">
        <div>
          <dufault-column height="auto" title="用户列表" v-loading="loading">
            <div slot="content">
              <el-table v-loading="tableLoading" :data="tableData" style="width: 100%; border-top: 1px solid #ddd;">
                <!-- <el-table-column prop="nickname" width="100px" label="昵称">
                  <template slot-scope="scope">
                    <a href="javascript:;" @click="handleDetails(scope.row.openid)" class="alink">{{scope.row.nickname}}&nbsp;&nbsp;</a>
                  </template>
                </el-table-column> -->
                <el-table-column prop="openid" width="230px" label="openid">
                  <template slot-scope="scope">
                    <a href="javascript:;" @click="handleDetails(scope.row.openid)" class="alink">{{scope.row.openid}}&nbsp;&nbsp;</a>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="unionid" width="230px" label="unionid"></el-table-column> -->
                <!-- <el-table-column prop="sex" width="50px" label="性别">
                  <template slot-scope="scope">
                    <div v-if="scope.row.sex">
                      {{String(scope.row.sex) === '1' ? '男' : (String(scope.row.sex) === '2' ? '女' : '未知')}}
                    </div>
                  </template>
                </el-table-column> -->
                <el-table-column prop="scene_name" label="首次访问方式"></el-table-column>
                <el-table-column prop="first_fromchannle_name" label="首次访问渠道"></el-table-column>
                <el-table-column prop="first_time_name" width="140px" label="首次访问时间"></el-table-column>
                <el-table-column prop="last_time_name" width="140px" label="末次访问时间"></el-table-column>
                <!-- <el-table-column prop="country" label="资料地理位置">
                  <template slot-scope="scope">
                    <div v-if="scope.row.country">
                      {{scope.row.country}} {{scope.row.province}}
                    </div>
                  </template>
                </el-table-column> -->
                <el-table-column prop="address" label="LBS地理位置">
                  <template slot-scope="scope">
                    <div v-if="scope.row.address">
                      {{scope.row.address.country}} {{scope.row.address.province}}
                    </div>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="subscribe_scene_name" label="关注方式"></el-table-column> -->
                <!-- <el-table-column prop="device.brand" label="设备品牌"></el-table-column>
                <el-table-column prop="os.family" label="操作系统"></el-table-column> -->
              </el-table>
              <div class="pagebox" v-if="count > limit">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="Number(page)"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="Number(limit)"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="count">
                </el-pagination>
              </div>
            </div>
          </dufault-column>
        </div>
      </el-col>
    </el-row>
    <el-dialog :close-on-click-modal="false" title="用户详情" :fullscreen="true" :visible.sync="dialogVisible" style="background: #eee;">
      <el-row :gutter="10" v-loading="dialogLoading">
        <el-col :span="6">
          <div v-if="!dialogLoading" class="details_dialog_sidebar">
            <!-- <div class="details_dialog_avatar">
              <img :src="detail.headimgurl" width="120" height="120" alt="">
            </div> -->
            <!-- <div class="details_dialog_cell">
              <div class="title">
                用户昵称
              </div>
              <div class="content">
                {{detail.nickname}}
              </div>
            </div> -->
            <div class="details_dialog_cell">
              <div class="title">
                用户 OpenID
              </div>
              <div class="content">
                {{detail.openid}}
              </div>
            </div>
            <div class="details_dialog_cell">
              <div class="title">
                用户 UnionId
              </div>
              <div class="content">
                {{detail.unionid}}
              </div>
            </div>
            <div class="details_dialog_cell">
              <div class="title">
                首次访问方式
              </div>
              <div class="content">
                {{detail.scene_name}}
              </div>
            </div>
            <div class="details_dialog_cell">
              <div class="title">
                首次访问渠道
              </div>
              <div class="content">
                {{detail.first_fromchannle_name}}
              </div>
            </div>
            <div class="details_dialog_cell">
              <div class="title">
                首次访问时间
              </div>
              <div class="content">
                {{detail.first_time_name}}
              </div>
            </div>
            <div class="details_dialog_cell">
              <div class="title">
                末次访问时间
              </div>
              <div class="content">
                {{detail.last_time_name}}
              </div>
            </div>
            <div v-if="detail.system_info && detail.system_info.brand" class="details_dialog_cell">
              <div class="title">
                设备品牌
              </div>
              <div class="content">
                {{detail.system_info.brand}}
              </div>
            </div>
            <!-- <div v-if="detail.system_info && detail.system_info.model" class="details_dialog_cell">
              <div class="title">
                设备型号
              </div>
              <div class="content">
                {{detail.system_info.model}}
              </div>
            </div> -->
            <div v-if="detail.system_info && detail.system_info.platform" class="details_dialog_cell">
              <div class="title">
                设备系统
              </div>
              <div class="content">
                {{detail.system_info.platform}}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="dialogright auto">
            <div class="dialogrighttop auto flex-box">
              <div class="topbox auto">
                行为总数
                <p><span>{{util.numberFormat(detail.total_active) || 0}}</span>&nbsp;次</p>
              </div>
              <div class="topbox auto">
                小程序打开次数
                <p><span>{{detail.active_info && detail.active_info.App_onShow ? detail.active_info.App_onShow : 0}}</span></p>
              </div>
              <div class="topbox auto">
                页面浏览次数
                <p><span>{{detail.active_info && detail.active_info.Page_onShow ? detail.active_info.Page_onShow : 0}}</span></p>
              </div>
            </div>
            <div class="dialogrightbot auto" v-loading="logLoading">
              <div class="dialog-bar">
                <dates-picker v-model="hDate" :dateRange="90" :closeclearable="true" size="small"></dates-picker>
                <!-- <el-select filterable v-model="type" size="small" placeholder="请选择">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select> -->
              </div>
              <el-collapse accordion v-if="dialogActive" v-model="boxIndex">
                <el-collapse-item v-for="(item, index) in dialogActive" :key="index" :name="index">
                  <template slot="title">
                    <span class="fl font14" style="margin-left: 10px">{{item.time}}</span><span class="fr font14" style="margin-right: 10px">行为数量：{{item.total}}</span>
                  </template>
                  <div v-for="(item2, index2) in item['active']" :key="index2" class="dialoglist">
                    <el-row>
                      <el-col :span="24">{{item2.time_name}}</el-col>
                    </el-row>
                    <el-row v-if="item2.scene_name === ''">
                      <el-col :span="10">
                        <span>
                          在&nbsp;
                        </span>
                        {{item2.route}}&nbsp;&nbsp;中触发
                      </el-col>
                      <el-col :span="14">
                        {{item2.event_name}}{{item2.data && item2.data.event_id && ':  ' + item2.data.event_name}}
                      </el-col>
                    </el-row>
                    <el-row v-else>
                      <el-col :span="10">
                        <span>
                          通过&nbsp;
                        </span>
                        {{item2.scene_name}} 触发
                      </el-col>
                      <el-col :span="14">
                        {{item2.event_name}}
                      </el-col>
                    </el-row>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <div class="pagebox" v-if="dialogCount > dialogLimit">
                <el-pagination
                  @size-change="dialogHandleSizeChange"
                  @current-change="dialogHandleCurrentChange"
                  :current-page="Number(dialogPage)"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="Number(dialogLimit)"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="count">
                </el-pagination>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { Data as DataModel } from '@/model'
// import { Data as DataController } from '@/controller'
export default {
  data () {
    return {
      loading: false,
      filters: {},
      chooseVal: {},
      chooseValStr: {},
      currentVal: {},
      page: 1,
      limit: 50,
      tableLoading: false,
      tableData: [],
      count: 0,
      openid: '',
      detail: {},
      dialogActive: {},
      boxIndex: 0,
      dialogVisible: false,
      dialogLoading: false,
      hDate: this.util.getDataPickerDefault(),
      type: 'mp',
      typeOptions: [
        {
          name: '公众号行为',
          value: 'mp'
        },
        {
          name: 'H5事件',
          value: 'tracker_event'
        },
        {
          name: '跳转链接',
          value: 'tracker_link'
        }
      ],
      dialogCount: 0,
      dialogPage: 1,
      dialogLimit: 100,
      logLoading: false,
      pickerOptions: {
        disabledDate (time) {
          var newDate = new Date()
          return time.getTime() > Date.now() || time.getTime() < (newDate.getTime() - 3600 * 1000 * 24 * 90)
          // return time.getTime() > Date.now() || time.getTime() < (Date.now() - 3600 * 1000 * 24 * 365)
          // return time.getTime() > Date.now()
        }
      }
    }
  },
  watch: {
    'type': function (val) {
      this.getUserDetailLog()
    },
    'hDate': function (val) {
      this.getUserDetailLog()
    }
  },
  methods: {
    getValues (obj) {
      console.log('obj', obj)
      if (obj.type) {
        this.chooseVal[obj.type] = obj['value']
      } else {
        this.chooseVal = obj['value']
      }
      let currentVal = {
        category_key: obj['type'],
        filter: {}
      }
      if (obj['value']['child_time']) {
        currentVal['child_time'] = obj['value']['child_time']
      }
      for (let key in obj['value']['filter']) {
        currentVal['filter'][key] = {}
        currentVal['filter'][key]['value'] = obj['value']['filter'][key]
      }
      this.currentVal = currentVal
      this.page = 1
      this.chooseVal = JSON.parse(JSON.stringify(this.chooseVal))
      this.getUserListByFilter()
    },
    async getUserDetailFilter () {
      this.loading = true
      let res = await DataModel.Miniv2.getFilterCriteria()
      if (!res['err_code']) {
        this.filters = res['data']
        var chooseValStr = {}
        for (let key in res['data']) {
          chooseValStr[key] = {}
          if (res['data'][key]['child_time'] && res['data'][key]['child_time'].length) {
            // chooseValStr[key]['child_time'] = []
            let child_time = {}
            res['data'][key]['child_time'].map(item => {
              child_time[item.key] = this.util.getDataPickerDefault()
            })
            chooseValStr['child_time'] = child_time
          }
          chooseValStr[key]['filter'] = {}
          for (let k in res['data'][key]['filter']) {
            if (res['data'][key]['filter'][k]['html_type'] === 'input') {
              chooseValStr[key]['filter'][k] = ''
            } else {
              chooseValStr[key]['filter'][k] = []
            }
          }
        }
        this.chooseVal = chooseValStr
        this.chooseValStr = JSON.parse(JSON.stringify(chooseValStr))
      }
      this.loading = false
    },
    handleSizeChange (val) {
      this.page = 1
      this.limit = val
      this.getUserListByFilter()
    },
    handleCurrentChange (val) {
      this.page = val
      this.getUserListByFilter()
    },
    async getUserListByFilter () {
      console.log('this.chooseVal', this.chooseVal)
      this.loading = true
      this.tableLoading = true
      let res = await DataModel.Miniv2.getUserListByFilter({
        filter: JSON.stringify(this.currentVal),
        page: this.page,
        size: this.limit
      })
      this.count = res['data']['total']
      this.tableData = res['data']['list']
      this.loading = false
      this.tableLoading = false
    },
    async handleDetails (openid) {
      this.openid = openid
      this.dialogVisible = true
      this.dialogLoading = true
      let res = await DataModel.Mini.getUserDetailSummary({
        openid: openid
      })
      this.getUserDetailLog()
      this.detail = res['data']
    },
    dialogHandleSizeChange (val) {
      this.dialogPage = 1
      this.dialogLimit = val
      this.getUserDetailLog()
    },
    dialogHandleCurrentChange (val) {
      this.dialogPage = val
      this.getUserDetailLog()
    },
    async getUserDetailLog () {
      this.logLoading = true
      let res = await DataModel.Miniv2.getUserDetailLog({
        openid: this.openid,
        begin_time: this.hDate[0],
        end_time: this.hDate[1],
        // type: this.type,
        page: this.dialogPage,
        size: this.dialogLimit
      })
      this.logLoading = false
      this.dialogLoading = false
      this.dialogCount = res['data']['total'] || 0
      this.dialogActive = res['data']['active'] || []
    }
  },
  created () {
    this.getUserDetailFilter()
  },
  mounted () {
  }
}
</script>
<style scoped>
/* .details_dialog_sidebar {
  width: 240px;
  float: left;
} */
.details_dialog_cell {
  margin-top: 20px;
  padding: 0 60px;
}
.details_dialog_cell .title {
  color: #999;
  font-size: 14px;
}
.details_dialog_cell .content {
  color: #4A4A4A;
  font-size: 14px;
}
.details_dialog_avatar {
  text-align: center;
  margin-bottom: 50px;
}
.details_dialog_avatar img {
  border-radius: 60px;
}
.pagebox {
  text-align: right;
  padding: 20px 0 0px;
}
.dialoglist {
  margin: 10px 10px 0;
  border-bottom: 1px solid rgba(220, 220, 220, .3);
  line-height: 24px;
  padding-bottom: 10px;
}
.dialogright {
  padding: 0 60px 0 20px;
}
.dialogrighttop {
  margin-bottom: 20px;
}
.topbox {
  /*float: left;*/
  flex: 1;
  border-right: 1px solid #eee;
  padding: 20px;
  font-size: 16px;
  color: #999;
  line-height: 30px;
  text-align: center;
}
.topbox p {
  font-size: 12px;
}
.topbox p span {
  font-size: 16px;
  color: #000;
}
.dialogrighttop div.topbox:last-child{
  border: none;
}
.dialog-bar {
  text-align: right;
  border-top: 1px solid #eee;
  padding: 10px 0;
}
</style>
